import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { Leaf, FileCheck, Scale, BarChart3, Building2 } from "lucide-react";
import { useLanguage, translations } from "@/i18n/LanguageContext";
import { Link } from "react-router-dom";

const icons = [Scale, BarChart3, Leaf, FileCheck, Building2];


const SustainabilitySection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-80px" });
  const { t } = useLanguage();

  return (
    <section id="baerekraft" ref={ref} className="section-padding py-24 md:py-36 bg-card">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-16 md:gap-24">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={isInView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.7 }}>
            <span className="text-sm font-body font-500 tracking-widest uppercase text-primary mb-4 block">{t(translations.sustainability.label)}</span>
            <h2 className="heading-lg text-foreground mb-6">{t(translations.sustainability.title)}</h2>
            <p className="body-lg text-muted-foreground mb-6">{t(translations.sustainability.description)}</p>
            <Link to="/baerekraft" className="inline-flex items-center text-primary font-display font-500 hover:underline transition-colors">
              {t(translations.sustainability.readMore)}
            </Link>
          </motion.div>

          <div className="grid gap-6">
            {translations.sustainability.pillars.map((pillar, i) => {
              const Icon = icons[i];
              return (
                <motion.div key={i} initial={{ opacity: 0, x: 20 }} animate={isInView ? { opacity: 1, x: 0 } : {}} transition={{ duration: 0.6, delay: 0.3 + i * 0.12 }} className="flex gap-5 p-5 rounded bg-background">
                  <div className="flex-shrink-0 w-10 h-10 rounded flex items-center justify-center bg-primary/10">
                    <Icon className="w-5 h-5 text-primary" />
                  </div>
                  <div>
                    <h3 className="font-display font-600 text-foreground mb-1">{t(pillar.title)}</h3>
                    <p className="text-sm font-body text-muted-foreground">{t(pillar.description)}</p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SustainabilitySection;
